import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Customer} from '../model/customer';

@Component({
    selector: 'customer-document',
    templateUrl: './customer-document.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerDocumentComponent {
  @Input() data: {customer: Customer};
  @Input() search: any;
}
